// extracted by mini-css-extract-plugin
export var checkbox = "_2y-0";
export var circle = "_2y-3";
export var horizontalContainer = "_2y-7";
export var sm = "_2y-5";
export var switch0 = "_2y-2";
export var switchDisabled = "_2y-8";
export var switchEnabled = "_2y-1";
export var textSwitchContainer = "_2y-9";
export var textSwitchOption = "_2y-a";
export var textSwitchOptionSelected = "_2y-b";
export var verticalContainer = "_2y-6";
export var xs = "_2y-4";